import type { RootState } from '@/store';
import { pureGetAllGridConnectionsById } from 'features/GridConnections';
import { getAllById, getById } from 'features/selectors';
import type { Asset } from 'types/swagger';

// Assets
export const pureGetAssetById = (state: RootState, id: number) => state.assets.byId[id];
export const pureGetAllAssetsById = (state: RootState): Record<number, Asset> => state.assets.byId;
export const getAllAssetsById = getAllById(
  pureGetAllAssetsById,
  { grid_connections: pureGetAllGridConnectionsById },
  { grid_connections: 'grid_connections' }
);
export const getAssetById = getById(
  pureGetAssetById,
  { grid_connections: pureGetAllGridConnectionsById },
  { grid_connections: 'grid_connections' }
);
export const assetsIsFetching = (state: RootState) => state.assets.isFetching;
export const getAllAssetsNamesById = (state: RootState) => state.assets.allNamesById;
